import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, createTextVNode as _createTextVNode, vShow as _vShow, withCtx as _withCtx, withDirectives as _withDirectives, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-container-col login-container" }
const _hoisted_2 = { class: "login-panel login-panel-wide" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 1,
  class: "unified-login-columns"
}
const _hoisted_6 = { class: "unified-login-column flex-container-col gap20" }
const _hoisted_7 = { class: "text-left" }
const _hoisted_8 = { class: "unified-login-divider" }
const _hoisted_9 = { class: "unified-login-divider-text" }
const _hoisted_10 = { class: "unified-login-column flex-container-col gap20" }
const _hoisted_11 = {
  key: 0,
  style: {"align-self":"center"}
}
const _hoisted_12 = {
  key: 1,
  class: "flex-container-col gap20"
}
const _hoisted_13 = { class: "text-left" }
const _hoisted_14 = { class: "flex-container-row gap20 text-left align-end" }
const _hoisted_15 = {
  class: "flex-container-col",
  style: {"flex-grow":"1"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_partner_login_form = _resolveComponent("partner-login-form")!
  const _component_loader = _resolveComponent("loader")!
  const _component_k_input = _resolveComponent("k-input")!
  const _component_error = _resolveComponent("error")!
  const _component_k_button = _resolveComponent("k-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isMaintenanceMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", { innerHTML: _ctx.maintenanceMessage }, null, 8, _hoisted_4)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.localize('ServiceTechnicians')) + " · " + _toDisplayString(_ctx.localize('Resellers')), 1),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.localize('PartnerLoginInfo')), 1),
              _createVNode(_component_partner_login_form)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.localize('Or')), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h1", null, _toDisplayString(_ctx.localize('Users')), 1),
              (_ctx.deviceState.loginInProgress)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createVNode(_component_loader, { size: "40%" })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.localize('EnterSerialNoInfo')), 1),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_k_input, {
                          id: "txtSerialNo",
                          placeholder: _ctx.localize('EnterEquipmentSerialNo'),
                          label: _ctx.localize('SerialNo'),
                          modelValue: _ctx.deviceState.serialNumber,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.deviceState.serialNumber) = $event)),
                          onInput: _ctx.onSerialNoInput,
                          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.searchDevice()), ["enter"]))
                        }, null, 8, ["placeholder", "label", "modelValue", "onInput"]),
                        _withDirectives(_createVNode(_component_error, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.localize('RequiredField')), 1)
                          ]),
                          _: 1
                        }, 512), [
                          [_vShow, _ctx.showSerialNoError]
                        ]),
                        (_ctx.deviceState.loginErrorMessage)
                          ? (_openBlock(), _createBlock(_component_error, { key: 0 }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.deviceState.loginErrorMessage), 1)
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _createVNode(_component_k_button, {
                        onClick: _ctx.searchDevice,
                        class: "unified-login-search-btn"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.localize('Search')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]))
            ])
          ]))
    ])
  ]))
}